import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getSpecializations, deleteSpecializations } from '../../../api/list'
import { useHistory, useLocation } from 'react-router-dom'

export default function SpecializationList() {
  const location = useLocation()
  const history = useHistory()
  return (
    <div className='App-paper'>
      <PageList
        name='specialization-list'
        columns={[{ id: 'name', name: 'Название' }]}
        createItem={true}
        deleteItem={true}
        loadAPI={{
          request: getSpecializations,
        }}
        deleteAPI={deleteSpecializations}
        pagination={false}
        tableProps={{
          pagination: false,
        }}
        location={location}
        history={history}
      />
    </div>
  )
};